import React, { useState } from "react";
import Cup from "../../../assets/icons/cup";
import {
  Container,
  Header,
  HeaderIcon,
  HeaderTitle,
  Table,
  Icon,
  ScrollableTBody,
  TableHeader,
  TableContainer,
  TaskCounter,
  Toggle,
  ToggleTest,
  ToggleMinhasTarefas,
  ToggleTodasTarefas,
  ScrollBarModifier,
  RefreshContainer,
  CustomDatePickerInput,
  DatePickerDisplay,
  FilterButton,
} from "./styles";
import CircularProgressBar from "./CircularBar";
import { CustomRefreshIcon } from "../DeDList/styles";
import { useDispatch } from "react-redux";
import { fetchDashboardUsers } from "../../../state/dashboard/actions";
import DatePicker from "react-datepicker";
import { debounce } from "lodash";

const BestWorkers = ({ dashUsers }) => {
  const [toggleState, setToggleState] = useState("semanal");
  const [sortedBy, setSortedBy] = useState("productivity");

  const dispatch = useDispatch();

  const ToggleComponent = () => {
    return (
      <Toggle>
        <ToggleTest toggleState={toggleState} />
        <ToggleMinhasTarefas
          onClick={() => {
            setToggleState("semanal");
          }}
        >
          Semanal
        </ToggleMinhasTarefas>
        <ToggleTodasTarefas
          onClick={() => {
            setToggleState("mensal");
          }}
        >
          Mensal
        </ToggleTodasTarefas>
      </Toggle>
    );
  };

  //? Finaly Creating the Implementation
  const monthlyData = [];
  const weeklyData = [];

  // Determinando o TimeFrame no momento so o semanal e mensal atual serão levados em consideração.
  const getStartOfWeek = () => {
    const now = new Date();
    const firstDayOfWeek = new Date(
      now.setDate(now.getDate() - now.getDay() + (now.getDay() === 0 ? -6 : 1))
    ); // Adjust to your week start day
    firstDayOfWeek.setHours(0, 0, 0, 0);
    return firstDayOfWeek;
  };

  const getStartOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  };

  const getMonthTimeFrame = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth(); // Note: JavaScript months are 0-indexed (0 for January, 1 for February, etc.)

    const startOfMonth = new Date(year, month, 1);
    const endOfMonth = new Date(year, month + 1, 0, 23, 59, 59, 999); // Last moment of the month

    return { startOfMonth, endOfMonth };
  };

  const getWeekTimeFrame = (date) => {
    const startOfWeek = new Date(date);
    startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay()); // Set to Sunday (start of the week)
    startOfWeek.setHours(0, 0, 0, 0); // Set start of the day

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6); // Move to end of the week (Saturday)
    endOfWeek.setHours(23, 59, 59, 999); // Set end of the day

    return { startOfWeek, endOfWeek };
  };

  //? Validando as Tasks a serem escolhidas unico metodo de criação no moment são os limitados a até o dia atual

  const processTasksToDay = (tasks, startTime, endTime) => {
    // This function now filters tasks based on their completion date, ensuring they fall within the given timeframe.
    return tasks.filter((task) => {
      const finishedAt = new Date(task.data.finishedAt);
      return finishedAt >= startTime && finishedAt <= endTime;
    });
  };

  const processTasksPeriod = (tasks, startTime, endTime) => {
    return tasks.filter((task) => {
      const finishedAt = task.data.finishedAt
        ? new Date(task.data.finishedAt)
        : null;
      const startedAt = new Date(task.data.startedAt);
      // Include tasks that either:
      // 1. Started at any time before the end time and are not finished, or
      // 2. Started before the end of the interval and finished at any time after the start time.
      return (
        (startedAt <= endTime && (!finishedAt || finishedAt >= startTime)) ||
        (startedAt <= endTime && finishedAt >= startTime)
      );
    });
  };

  //? Calcular Produtividade dos Trabalhadores

  const calculateProductivity = (doneTasks, doneLateTasks, lateTasks) => {
    let totalEstimatedDuration = 0;
    let totalActualDuration = 0;

    doneTasks.forEach((task) => {
      totalEstimatedDuration += task.data.expiration.number;
      totalActualDuration +=
        task.data.expiration.number - task.moment.diffHours;
    });

    doneLateTasks.forEach((task) => {
      totalEstimatedDuration += task.data.expiration.number;
      totalActualDuration +=
        task.data.expiration.number - task.moment.diffHours;
    });

    lateTasks.forEach((lateTask) => {
      totalActualDuration += -lateTask.moment.diffHours;
    });

    // Calculate productivity
    let productivity =
      totalActualDuration === 0
        ? 0
        : (totalEstimatedDuration / totalActualDuration) * 100;

    // Ensure productivity doesn't fall below zero
    productivity = Math.max(productivity, 0);

    return productivity;
  };

  //? Popular as Listas

  const populateData = (workers) => {
    const startOfWeek = getStartOfWeek();
    const startOfMonth = getStartOfMonth();
    const now = new Date(); // Assuming you want to count up to the current date

    workers.forEach((worker) => {
      const weeklyDoneTasks = processTasksToDay(
        worker?.taskMap.done,
        startOfWeek,
        now
      );
      const weeklyDoneLateTasks = processTasksToDay(
        worker?.taskMap.doneLate,
        startOfWeek,
        now
      );

      weeklyData.push({
        name: worker?.username,
        avatar: worker?.avatarURL,
        doingTasks: worker?.taskMap.doing,
        lateTasks: worker?.taskMap.late,
        pendingTasks: worker?.taskMap.pending,
        doneTasks: weeklyDoneTasks,
        doneLateTasks: weeklyDoneLateTasks,
        productivity: calculateProductivity(
          weeklyDoneTasks,
          weeklyDoneLateTasks,
          worker?.taskMap.late
        ),
      });

      const monthlyDoneTasks = processTasksToDay(
        worker?.taskMap.done,
        startOfMonth,
        now
      );
      const monthlyDoneLateTasks = processTasksToDay(
        worker?.taskMap.doneLate,
        startOfMonth,
        now
      );

      monthlyData.push({
        name: worker.username,
        avatar: worker.avatarURL,
        doingTasks: worker?.taskMap.doing,
        lateTasks: worker?.taskMap.late,
        pendingTasks: worker?.taskMap.pending,
        doneTasks: monthlyDoneTasks,
        doneLateTasks: monthlyDoneLateTasks,
        productivity: calculateProductivity(
          monthlyDoneTasks,
          monthlyDoneLateTasks,
          worker?.taskMap.late
        ),
      });
    });
  };

  populateData(dashUsers.data);

  // weeklyData.sort((a, b) => b.productivity - a.productivity);
  // monthlyData.sort((a, b) => b.productivity - a.productivity);

  //? Implementando Seleção Semanal e Mensal
  const [selectedWeek, setSelectedWeek] = useState({
    data: [],
    isMounted: false,
    weekStart: null,
    WeekEnds: null,
  });
  const [selectedMonth, setSelectedMonth] = useState({
    data: [],
    isMounted: false,
    start: null,
  });

  const DisplayUsers =
    toggleState === "semanal"
      ? selectedWeek.isMounted
        ? selectedWeek.data
        : weeklyData
      : selectedMonth.isMounted
      ? selectedMonth.data
      : monthlyData;

  const populateSelectedWeek = (workers, weekStart, WeekEnds) => {
    const updatedWeeklyData = workers.map((worker) => {
      const weeklyDoingTasks = processTasksPeriod(
        worker?.taskMap.doing,
        weekStart,
        WeekEnds
      );

      const weeklyLateTasks = processTasksPeriod(
        worker?.taskMap.late,
        weekStart,
        WeekEnds
      );

      const weeklyPendingTasks = processTasksPeriod(
        worker?.taskMap.pending,
        weekStart,
        WeekEnds
      );

      const weeklyDoneTasks = processTasksPeriod(
        worker?.taskMap.done,
        weekStart,
        WeekEnds
      );

      const weeklyDoneLateTasks = processTasksPeriod(
        worker?.taskMap.doneLate,
        weekStart,
        WeekEnds
      );

      return {
        name: worker?.username,
        avatar: worker?.avatarURL,
        doingTasks: weeklyDoingTasks,
        lateTasks: weeklyLateTasks,
        pendingTasks: weeklyPendingTasks,
        doneTasks: weeklyDoneTasks,
        doneLateTasks: weeklyDoneLateTasks,
        productivity: calculateProductivity(
          weeklyDoneTasks,
          weeklyDoneLateTasks,
          weeklyLateTasks
        ),
      };
    });
    setSelectedWeek({
      data: updatedWeeklyData,
      isMounted: true,
      weekStart: weekStart,
      WeekEnds: WeekEnds,
    });
  };
  const populateSelectedMonth = (workers, weekStart, WeekEnds) => {
    const updatedData = workers.map((worker) => {
      const weeklyDoingTasks = processTasksPeriod(
        worker?.taskMap.doing,
        weekStart,
        WeekEnds
      );

      const weeklyLateTasks = processTasksPeriod(
        worker?.taskMap.late,
        weekStart,
        WeekEnds
      );

      const weeklyPendingTasks = processTasksPeriod(
        worker?.taskMap.pending,
        weekStart,
        WeekEnds
      );

      const weeklyDoneTasks = processTasksPeriod(
        worker?.taskMap.done,
        weekStart,
        WeekEnds
      );

      const weeklyDoneLateTasks = processTasksPeriod(
        worker?.taskMap.doneLate,
        weekStart,
        WeekEnds
      );

      return {
        name: worker?.username,
        avatar: worker?.avatarURL,
        doingTasks: weeklyDoingTasks,
        lateTasks: weeklyLateTasks,
        pendingTasks: weeklyPendingTasks,
        doneTasks: weeklyDoneTasks,
        doneLateTasks: weeklyDoneLateTasks,
        productivity: calculateProductivity(
          weeklyDoneTasks,
          weeklyDoneLateTasks,
          weeklyLateTasks
        ),
      };
    });
    setSelectedMonth({
      data: updatedData,
      isMounted: true,
      start: weekStart,
    });
  };

  const CalendarIcon = ({ isSelected }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{ color: isSelected ? "#40e5A0" : "black" }}
    >
      <path
        fill="currentColor"
        d="M19 3h-1V2h-2v1H8V2H6v1H5c-1.11 0-1.99.89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16H5V8h14v11zm-2-9H7v2h10V10zm-3 4H7v2h7v-2z"
      />
    </svg>
  );

  const CustomInput = React.forwardRef(
    ({ value, onClick, isSelected }, ref) => {
      let displayValue = "";
      let displayValue2 = "";
      if (
        toggleState === "semanal" &&
        selectedWeek &&
        selectedWeek.weekStart &&
        selectedWeek.WeekEnds
      ) {
        const start =
          selectedWeek.weekStart.getDate() +
          "/" +
          (selectedWeek.weekStart.getMonth() + 1); // Adding 1 because getMonth() is zero-based
        const end =
          selectedWeek.WeekEnds.getDate() +
          "/" +
          (selectedWeek.WeekEnds.getMonth() + 1);
        const year1 = selectedWeek.weekStart.getFullYear(); // Use getFullYear() for the full year
        const year2 = selectedWeek.WeekEnds.getFullYear();
        displayValue = `${start} - ${end}`;
        displayValue2 = year1 === year2 ? `${year1}` : `${year1}/${year2}`;
      } else if (
        toggleState === "mensal" &&
        selectedMonth &&
        selectedMonth.start
      ) {
        const month = selectedMonth.start.getMonth() + 1; // Get the month and adjust for zero-based index
        const year = selectedMonth.start.getFullYear(); // Get the full year
        displayValue = `${month}/${year}`; // Adjust format to match your desired "MM/yyyy"
      }

      return (
        <CustomDatePickerInput
          onClick={(e) => {
            e.stopPropagation(); // Prevent DatePicker from capturing this click
            if (isSelected) {
              if (toggleState === "semanal") {
                setSelectedWeek({
                  data: {},
                  isMounted: false,
                  weekStart: null,
                  WeekEnds: null,
                });
              } else {
                setSelectedMonth({ data: {}, isMounted: false, start: null });
              }
            } else {
              onClick(); // This triggers the date picker's default behavior
            }
          }}
          className="date-picker-button"
          ref={ref} // Pass the ref to the button
          isSelected={isSelected}
        >
          <CalendarIcon isSelected={isSelected} />
          {displayValue ? (
            toggleState === "semanal" ? (
              <DatePickerDisplay>
                <span
                  style={{
                    fontSize: "10px",
                    borderBottom: `solid 1px #40e5A0`,
                    width: "56px",
                    color: "#40e5A0",
                  }}
                >
                  {displayValue}
                </span>
                <span
                  style={{ fontSize: "10px", width: "56px", color: "#40e5A0" }}
                >
                  {displayValue2}
                </span>
              </DatePickerDisplay>
            ) : (
              <span
                style={{
                  fontSize: "12px",
                  width: "56px",
                  color: "#40e5A0",
                }}
              >
                {displayValue}
              </span>
            )
          ) : (
            <span style={{ fontSize: "12px", width: "56px" }}>Atual</span>
          )}
        </CustomDatePickerInput>
      );
    }
  );

  const getMaxDateForWeek = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // Day of week, 0 (Sunday) to 6 (Saturday)
    const maxDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - dayOfWeek - 1 // Subtracting 1 more to exclude current week's Sunday
    );
    maxDate.setHours(23, 59, 59, 999); // Set to the end of Saturday
    return maxDate;
  };

  const getMaxDateForMonth = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 0); // 0th day of the current month is the last day of the previous month
  };

  const loading = dashUsers?.status === "loading";

  const handleDebouncedRefresh = debounce(() => {
    dispatch(fetchDashboardUsers());
  }, 400);

  const getTotalTasks = (user) => {
    const { doingTasks, lateTasks, doneTasks, doneLateTasks, pendingTasks } =
      user;
    return (
      doingTasks.length +
      lateTasks.length +
      doneTasks.length +
      doneLateTasks.length +
      pendingTasks.length
    );
  };
  const getSortedList = (users, sortOrder = "desc") => {
    if (!sortedBy) return users;

    const key =
      sortedBy === "total" || sortedBy === "productivity"
        ? sortedBy
        : `${sortedBy}Tasks`;

    return [...users].sort((a, b) => {
      if (sortedBy === "total") {
        return sortOrder === "asc"
          ? getTotalTasks(a) - getTotalTasks(b)
          : getTotalTasks(b) - getTotalTasks(a);
      }

      if (sortedBy === "productivity") {
        return sortOrder === "asc"
          ? a.productivity - b.productivity
          : b.productivity - a.productivity;
      }

      const aCount = (a[key] || []).length;
      const bCount = (b[key] || []).length;

      return sortOrder === "asc" ? aCount - bCount : bCount - aCount;
    });
  };

  const sortedList = getSortedList(DisplayUsers);

  return (
    <Container>
      <Header>
        <HeaderIcon>
          <Cup />
        </HeaderIcon>
        <HeaderTitle>Ranking de Produtividade</HeaderTitle>
        <ToggleComponent />
        <DatePicker
          onChange={(date) => {
            if (toggleState === "semanal") {
              const { startOfWeek, endOfWeek } = getWeekTimeFrame(date);
              populateSelectedWeek(dashUsers.data, startOfWeek, endOfWeek);
            } else {
              const { startOfMonth, endOfMonth } = getMonthTimeFrame(date);
              populateSelectedMonth(dashUsers.data, startOfMonth, endOfMonth);
            }
          }}
          showMonthYearPicker={toggleState === "mensal"}
          customInput={
            <CustomInput
              isSelected={
                (selectedWeek.isMounted && toggleState === "semanal") ||
                (selectedMonth.isMounted && toggleState !== "semanal")
              }
            />
          }
          locale="pt-BR"
          dateFormat="dd/MM/yyyy"
          maxDate={
            toggleState === "semanal"
              ? getMaxDateForWeek()
              : getMaxDateForMonth()
          }
        />
        <RefreshContainer>
          <CustomRefreshIcon
            style={{ opacity: loading ? 0.5 : 1 }}
            onClick={() => {
              if (loading) return;
              handleDebouncedRefresh();
            }}
          />
        </RefreshContainer>
      </Header>
      <ScrollBarModifier>
        <TableContainer>
          <Table>
            <TableHeader>
              <tr>
                <th></th>
                <th></th>
                <th>
                  <FilterButton
                    sortBy={sortedBy === "pending"}
                    onClick={() => setSortedBy("pending")}
                  >
                    Pendente
                  </FilterButton>
                </th>
                <th>
                  <FilterButton
                    sortBy={sortedBy === "doing"}
                    onClick={() => setSortedBy("doing")}
                  >
                    Execução
                  </FilterButton>
                </th>
                <th>
                  <FilterButton
                    sortBy={sortedBy === "late"}
                    onClick={() => setSortedBy("late")}
                  >
                    Atrasada
                  </FilterButton>
                </th>
                <th>
                  <FilterButton
                    sortBy={sortedBy === "done"}
                    onClick={() => setSortedBy("done")}
                  >
                    Concluídas
                  </FilterButton>
                </th>
                <th>
                  <FilterButton
                    sortBy={sortedBy === "doneLate"}
                    onClick={() => setSortedBy("doneLate")}
                  >
                    C.atraso
                  </FilterButton>
                </th>
                <th>
                  <FilterButton
                    sortBy={sortedBy === "total"}
                    onClick={() => setSortedBy("total")}
                  >
                    Total
                  </FilterButton>
                </th>
                <th>
                  <FilterButton
                    sortBy={sortedBy === "productivity"}
                    onClick={() => setSortedBy("productivity")}
                  >
                    Produtividade
                  </FilterButton>
                </th>
              </tr>
            </TableHeader>
            <ScrollableTBody>
              {sortedList.length > 0 && dashUsers.status === "succeeded" ? (
                sortedList.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Icon>
                        <img alt="" src={item.avatar} />
                      </Icon>
                    </td>
                    <td>{item.name.split(" ")[0]}</td>
                    <td>
                      <TaskCounter status="pending">
                        {item.pendingTasks.length}
                      </TaskCounter>
                    </td>
                    <td>
                      <TaskCounter status="doing">
                        {item.doingTasks.length}
                      </TaskCounter>
                    </td>
                    <td>
                      <TaskCounter status="late">
                        {item.lateTasks.length}
                      </TaskCounter>
                    </td>
                    <td>
                      <TaskCounter status="done">
                        {item.doneTasks.length}
                      </TaskCounter>
                    </td>
                    <td>
                      <TaskCounter status="doneLate">
                        {item.doneLateTasks.length}
                      </TaskCounter>
                    </td>
                    <td>
                      <TaskCounter status="total">
                        {getTotalTasks(item)}
                      </TaskCounter>
                    </td>
                    <td>
                      <CircularProgressBar
                        productivity={Math.floor(item.productivity)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">Carregando Informações</td>
                </tr>
              )}
            </ScrollableTBody>
          </Table>
        </TableContainer>
      </ScrollBarModifier>
    </Container>
  );
};

export default BestWorkers;
